import { useMutation } from "@tanstack/react-query";
import api from "utils/api";
import { endpoints } from "utils/endpoints";

export function SendOverDueEmail() {
  return useMutation({
    mutationFn: () => api.get<boolean>(endpoints.email.sendOverdueEmail),
  });
}

export function SendSelectedOverdueEmail() {
  return useMutation({
    mutationFn: (issueIDs: (string | number)[]) =>
      api.post<boolean>(endpoints.email.sendSelectedOverdueEmail, { issueIDs }),
  });
}
